import { useEffect, useRef, useState } from "react";
export const useWatchObservableValue = (observable) => {
    const watchedObservable = useRef(observable);
    const [watchedValue, setWatchedValue] = useState(observable.value);
    useEffect(() => {
        watchedObservable.current = observable;
        setWatchedValue(observable.value);
        return observable.observe(setWatchedValue);
    }, [observable]);
    const observableHasChanged = watchedObservable.current !== observable;
    return observableHasChanged ? observable.value : watchedValue;
};
